module.exports = __webpack_public_path__ + "static/media/amazontv-new.944a65f2.png";